export const GRID_COLUMNS = 24;
export const GRID_ROWS = 18;

export const constants = {
  GRID_COLUMNS,
  GRID_ROWS,
};

export default constants;
